import apiClient from '@/services/axios'

/**
 * Get all buildings with calendar information
 * @param {number|null} districtId Optional district ID to filter buildings
 * @returns {Promise} Response with buildings that have iCal URLs
 */
export function getBuildingsWithCalendars(districtId = null) {
  const url = districtId 
    ? `/calendar/buildings?districtId=${districtId}`
    : '/calendar/buildings'
  return apiClient.get(url)
}

/**
 * Get events for selected buildings
 * @param {number[]} buildingIds Array of building IDs
 * @returns {Promise} Response with calendar events
 */
export function getCalendarEvents(buildingIds) {
  const params = buildingIds.map(id => `buildingIds=${id}`).join('&')
  return apiClient.get(`/calendar/events?${params}`)
}

/**
 * Create a new calendar event
 * @param {Object} eventData Event data with targets and shares
 * @returns {Promise} Response with created event
 */
export function createCalendarEvent(eventData) {
  return apiClient.post('/calendar/events', eventData)
}

/**
 * Delete a calendar event (soft delete)
 * @param {number} eventId The DB event ID
 * @returns {Promise} Response with success status
 */
export function deleteCalendarEvent(eventId) {
  return apiClient.delete(`/calendar/events/${eventId}`)
}

/**
 * Get events created by the current user
 * @returns {Promise} Response with user's events
 */
export function getMyCalendarEvents() {
  return apiClient.get('/calendar/events/my')
}
